<template>
  <SanFormStatic
    v-model:errors="errors"
    :ok-button="okButton"
    :cancel-button="cancelButton"
    @submit="onSubmit"
  >
    <component
      v-bind="field"
      :is="field.component"
      v-for="field in fields"
      :key="field.name"
    />
  </SanFormStatic>
</template>

<script setup>
import { ref, computed, markRaw } from 'vue'
import { useLoadComponent } from '@/composables'
import { capitalize } from 'lodash'

defineOptions({ name: 'SanFormDynamic' })
const emit = defineEmits(['submit'])
const props = defineProps({
  okButton: { type: Object, default: null },
  cancelButton: { type: Object, default: null },
  fields: { type: Array, required: true }
})

const errors = ref({})

const fields = computed(() => props.fields.map(f => {
  // f.component = !f.hidden ? markRaw(useLoadComponent(`components/forms/SanField${capitalize(f.as || 'Input')}.vue`)) : 'input'
  const name = f.hidden ? 'Hidden' : f.as || 'Input'
  // let name
  // if (f.hidden) {
  //   name = 'Hidden'
  // } else if (f.name === 'password') {
  //   name = f.as || 'Input'
  // } else {
  //   name = 'Input'
  // }
  f.component = markRaw(useLoadComponent(`components/forms/SanField${capitalize(name)}.vue`))
  return f
}))

const onSubmit = data => {
  console.log('onSubmit', data)
  emit('submit', data)
}
</script>
